import { component } from 'picoapp'
import { getSizedImageUrl, imageSize } from '@/lib/images.js'
import { formatMoney } from '@/lib/currency.js'
import app from '@/app.js'
import '@/lib/jquery-global.js';
import { addVariant, addItemById } from '@/lib/cart.js'
// import updateThreshold from '../lib/threshold';


const X = `//cdn.shopify.com/s/files/1/0325/1820/9671/t/2/assets/icon-trash.svg`

var empty_1 = '//cdn.shopify.com/s/files/1/0325/1820/9671/files/empty-1.svg?v=1584387456';
var empty_2 = '//cdn.shopify.com/s/files/1/0325/1820/9671/files/empty-2.svg?v=1584387464';

const cutouts = JSON.parse(document.querySelector('.js-cutouts').innerHTML)

function createItem ({
  variant_id: id,
  product_title: title,
  line_price: price,
  variant_title: color,
  image,
  url,
  quantity,
  ...item
}) {
  const img = image ? getSizedImageUrl(
    image.replace('.' + imageSize(image), ''), '200x' // TODO hacky af
  ) : 'https://source.unsplash.com/R9OS29xJb-8/2000x1333'

  var cutout_img = 'https://source.unsplash.com/R9OS29xJb-8/200x200';


  cutouts.variants.forEach(function(el) {
    if (el.id == id) {
      if (el.image) {
        cutout_img = el.image
      }
    }
  })

  let prevent_click = ''

  if (id == '34541701988507') {
    prevent_click = 'pointer-events--none'
  }

  return `
<div class='cart-drawer__item' data-component='cartDrawerItem' data-id=${id}>
  <div class='flex items-start'>
    <div class='cart-drawer__item-image mr-6'>
      <div>
        <a href='${url}' class='${prevent_click}'>
          <img src='${cutout_img}' class='cutout' />
        </a>
      </div>
    </div>
    <div class='__content pl1 flex h-full flex-1 justify-between items-end'>
      <div>
        <a href='${url}' class='serif font-medium block mb-2 text-base ${prevent_click}'>${title}</a>
        ${color ? `<div class='sans cm mb-4 book'>${color.replace("/", "<span class='px-2 bullet'>&bull;</span>")}</div>` : ``}
        <div class='small sans mb-4'>${formatMoney(price)}</div>
        <div class='inline-block'>
          <div class='counter flex justify-between items-center border bg-white text-sm font-medium py-2'>
            <button class='cart-quantity js-remove-single'>-</button>
            <div class='p-0 js-single-quantity input'>${quantity}</div>
            <button class='cart-quantity js-add-single'>+</button>
          </div>
        </div>
      </div>

      <button class='button--reset js-remove-item'><img src='${X}' /></button>
    </div>
  </div>
</div>
`
}

function renderItems (items) {
  return items.length > 0 ? (
    items.reduce((markup, item) => {
      markup += createItem(item)
      return markup
    }, '')
  ) : (
    `<div class='absolute h-full w-full flex items-center justify-center text-center'><div><p class='font-medium font-display text-5xl md:text-6xl leading-none mb-20'>Your cart is empty</p><div class='absolute empty-1'><a href='/products/the-lunch-kit' class='block'><img src='${empty_1}' /></a></div><div class='absolute empty-2'><a href='/products/food-containers' class='block'><img src='${empty_2}' /></a></div></div></div>`
  )
}

export default component((node, ctx) => {
  const overlay = node.querySelector('.js-overlay')
  const closeButton = node.querySelector('.js-close')
  const subtotal = node.querySelector('.js-subtotal')
  const itemsRoot = node.querySelector('.js-items')
  const containerRoot = node
  // const loading = itemsRoot.innerHTML

  const render = (cart) => {
    itemsRoot.innerHTML = renderItems(cart.items)
    containerRoot.dataset.quantity = cart.item_count
    subtotal.innerHTML = formatMoney(cart.total_price)
  }

  const open = (cart) => {
    node.classList.add('is-active')
    // itemsRoot.innerHTML = loading
    setTimeout(() => {
      node.classList.add('is-visible')
      setTimeout(render(cart), 10)
      app.mount()
    }, 50)
  }

  const close = () => {
    node.classList.remove('is-visible')
    setTimeout(() => {
      node.classList.remove('is-active')
      app.hydrate({ cartOpen: false })

    }, 400)
  }

  render(ctx.getState().cart)

  overlay.addEventListener('click', close)
  closeButton.addEventListener('click', close)

  ctx.on('cart:toggle', ({ cart, cartOpen }) => {
    cartOpen && open(cart)
  })
  ctx.on('cart:updated', () => {
    render(ctx.getState().cart)
    app.mount()
  })


  jQuery('.js-toggle-gift').click(function () {
    $('.js-gift-drawer').slideToggle();
    jQuery('.js-toggle-gift').toggleClass('gift--open')
  })

  const checkout_button = jQuery('.js-checkout')

  checkout_button.click(async function() {

    let to_name = "To - " + jQuery('.gift_input_to_drawer').val() + "\n";
    let from_name = "From - " + jQuery('.gift_input_from_drawer').val() + "\n";
    let message = "Message - " + jQuery('.gift_input_message_drawer').val() + "\n";
    let gift_wrap = "Gift Wrap - " + jQuery('#gift_wrap_drawer').prop('checked');

    let note_content = to_name + from_name + message + gift_wrap;

    if (jQuery('#gift_wrap_drawer').prop('checked')) {
      await addItemById('34541701988507', 1);
    } else {
      await addItemById('34541701988507', 0);
    }

    $.ajax({
      url: '/cart/update.js',
      type: 'POST',
      data: {note: note_content},
      success: function(result) { 
        if (typeof sasoCheckout != "function") {
          window.location = "/checkout";
        } else {
          window.sasoCheckout()
        }
      },
      error: function(jqxhr, status, exception) {
          console.log(exception);
      }
    });

  });

})
